import React, { useState } from 'react';
import { TextField, Typography, Box } from '@mui/material';

const ReadOnlyTextFields = ({
  value = '',
  textStyle = {
    padding: 1.75,
    left: { fontSize: '0.875rem', fontWeight: 500, color: 'text.primary' },
    right: { fontSize: '0.875rem', fontWeight: 500, color: 'text.primary' },
  },
  ...otherProps
}) => {
  const isArray = Array.isArray(value);
  const [isFocused, setIsFocused] = useState(false);

  let leftText = '';
  let rightText = '';

  let displayValue = value;
  if (isArray) {
    leftText = value[0]?.toString?.() || '';
    rightText = value[1]?.toString?.() || '';
    displayValue = `${leftText} ${rightText}`;
  }

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TextField
        {...otherProps}
        fullWidth
        variant="outlined"
        value={displayValue}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        InputLabelProps={{
          sx: { color: 'text.primary' },
        }}
        InputProps={{
          readOnly: true,
          sx: {
            userSelect: 'text',
            cursor: 'text',
            color: isArray && !isFocused ? 'transparent' : 'inherit',
            caretColor: isArray ? 'transparent' : 'inherit',
            '& input': {
              textShadow: isArray && !isFocused ? '0 0 0 transparent' : 'none',
              userSelect: 'text',
            },
          },
        }}
        style={{
          userSelect: 'text',
          pointerEvents: 'auto',
        }}
      />
      {isArray && !isFocused && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pointerEvents: 'none',
            fontFamily: 'monospace',
            px: textStyle?.padding ?? 1.75,
            zIndex: 1,
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: textStyle?.left?.fontSize,
              fontWeight: textStyle?.left?.fontWeight,
              color: textStyle?.left?.color ?? 'text.primary',
            }}
          >
            {leftText}
          </Typography>
          <Typography
            component="span"
            sx={{
              fontSize: textStyle?.right?.fontSize,
              fontWeight: textStyle?.right?.fontWeight,
              color: textStyle?.right?.color ?? 'text.primary',
            }}
          >
            {rightText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ReadOnlyTextFields;
